import Modal from "react-bootstrap/Modal";
import AddRole from "../AddRoleComponent/AddRole";
import { ModalBody } from "react-bootstrap";
import "./centeredModal.css";

function CenteredModal({
  showAddRole,
  onHide,
  roleName,
  setRoleName,
  addOrEdit,
  setAddOrEdit,
  submitAddRole,
  showRoleNameRequiredError,
  onChangeInput
}) {
  return (
    <Modal
      show={showAddRole}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="modal-close-button"></Modal.Header>
      <ModalBody>
        <AddRole
          roleName={roleName}
          setRoleName={setRoleName}
          addOrEdit={addOrEdit}
          setAddOrEdit={setAddOrEdit}
          submitAddRole={submitAddRole}
          showRoleNameRequiredError={showRoleNameRequiredError}
          onChangeInput={onChangeInput}
        />
      </ModalBody>
    </Modal>
  );
}

export default CenteredModal;
